import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import {
  FaInstagram,
  FaFacebookF,
  FaLinkedinIn,
  FaTwitter,
  FaPinterestP,
} from "react-icons/fa";
import "../components/Sidebar.css";
import { RxCross2 } from "react-icons/rx";
import { Link as L } from "react-scroll";

import { HiOutlineChevronDown } from "react-icons/hi";
import sublinks from "../newData.js";

const Sidebar = ({ setClick, click }) => {
  const [state, setState] = useState(false);

  const showMenu = () => {
    console.log("hii");
    setState((prev) => !prev);
  };

  return (
    <section className="section-sidebar">
      <aside className="aside">
        <RxCross2
          style={{
            fontSize: "2rem",
            position: "absolute",
            top: "14px",
            right: "22px",
            cursor: "pointer",
          }}
          onClick={() => setClick(false)}
        />
        <div className="sidebar-content">
          <a href="https://incretech.in/" onClick={() => setClick(false)}>
            <p>Home</p>
          </a>

          <div
            className="services-link"
            style={{
              display: "flex",
              alignItems: "center",
              columnGap: ".3em",
            }}
          >
            Services <HiOutlineChevronDown onClick={showMenu} />
          </div>

          {state && (
            <div style={{ margin: "0 1.2em" }}>
              {sublinks.map((link, i) => (
                <div key={link.id}>
                  <a
                    href=""
                    // to={`/${link.link}`}
                    className="sub-menu"
                    onClick={() => setClick(false)}
                  >
                    {link.name}
                  </a>
                </div>
              ))}
            </div>
          )}

          {/* <a href="#teams" onClick={() => setClick(false)}>
            <p>Teams</p>
          </a> */}

          <a
            href="https://incretech.in/about"
            to="about"
            onClick={() => setClick(false)}
          >
            <p>About</p>
          </a>
          <a
            href="https://incretech.in/career"
            to="career"
            onClick={() => setClick(false)}
          >
            <p>Career</p>
          </a>
          <a
            href="https://incretech.in/contact"
            to="contact"
            onClick={() => setClick(false)}
          >
            <p>contact</p>
          </a>
          <a
            href="https://shop.incretech.in/"
            target="_blank"
            className="shop-now"
          >
            Shop Now
          </a>
        </div>

        <div className="developed">
          <p>developed by incretech</p>
        </div>
      </aside>

      <div
        className={`${click && "overlay-sidebar"}`}
        onClick={() => setClick(false)}
      ></div>
    </section>
  );
};

export default Sidebar;
